// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__Xtw+V","modal":"Modal_modal__yEgVW","close":"Modal_close__nnot4","title":"Modal_title__KuCmT","title2":"Modal_title2__kNkJ+"};